<template>
  <v-container grid-list-xs class="pa-0 ma-0">
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <div class="d-flex flex-row justify-center subtitle-1 flex-wrap ma-10"
      v-if="(!schedules || schedules.length == 0) && !loading">
      {{ (status === 'all')
        ? `Nenhum agendamento encontrado`
        : `Nenum agendamento com status ${statusFrmt[status].lbl}`
      }}
    </div>

    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item v-for="(schedule, i) in schedules" :key="schedule.id" color="red lighten-2">
        <template v-slot:icon v-if="schedule">
          <v-avatar >
            <img :src="schedule.avatar" />
          </v-avatar>
        </template>

        <my-schedule-card v-model="schedules[i]" @open="open"/>
      </v-timeline-item>
    </v-timeline>
    </v-container>
</template>

<script>
import MyScheduleCard from '@/components/mySchedules/MyScheduleCard';

export default {
  props: {
    patientId: {
      type: [Number, String],
    },
    status: {
      type: String,
    },
  },
  data: () => ({
    schedules: [],
    loading: false,
  }),
  created() {
    this.getSchedules();
  },
  methods: {
    getSchedules() {
      this.loading = true;
      this.$store
        .dispatch('patientSchedules/getByStatus', {
          patientId: this.patientId,
          status: this.status,
        })
        .then((schedules) => {
          this.schedules = schedules;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(schedule) {
      const queryBase64 = btoa(JSON.stringify({ patient: { id: schedule.patientId, name: schedule.patient } }));
      this.$router.push({ name: 'calendar-view', params: { id: schedule.calendarId }, query: { q: queryBase64 } });
    },
  },
  watch: {
    status() {
      this.getSchedules();
    },
  },
  components: {
    MyScheduleCard,
  },
};
</script>
